import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import utils from '../utils'
import {
    FaHeart,
    FaShieldAlt,
    FaClock,
    FaMapMarkerAlt,
    FaStar,
    FaArrowRight,
    FaHeartbeat,
    FaHandHoldingHeart,
} from 'react-icons/fa';
import {
    FaUserNurse,
    FaClipboardList,
    FaFileUpload,
    FaMoneyBillWave,
} from 'react-icons/fa';
import { MdVerified } from "react-icons/md";
import { MdHealthAndSafety, MdSupportAgent } from 'react-icons/md';
// import { TbHeartHandshake } from 'react-icons/tb';
import { FaDownload, FaFileMedical, FaHouseMedical } from 'react-icons/fa6';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

function AboutPage(props) {
    const url = window.location.href
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
    }, [location.hash]);
    return (
        <div>
            <Helmet>
                <title>About Us - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta
                    name="description"
                    content="HealthConnect connects Kenyan families with verified, certified nurses who deliver hospital-grade healthcare services at home. Learn about our mission, vision, and vetting process."
                />
                <meta
                    property="og:title"
                    content="About HealthConnect - Quality Home Healthcare in Kenya"
                />
                <meta
                    property="og:description"
                    content="We bridge the gap between clinical excellence and compassionate care. Connect with vetted nurses for hospital-grade healthcare at home."
                />
                <meta
                    property="og:type"
                    content="website"
                />
                <meta
                    property="og:url"
                    content={url}
                />
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />
                <meta
                    name="keywords"
                    content="home healthcare Kenya, certified nurses, nurse booking, medical care at home, HealthConnect, verified nurses Kenya"
                />
            </Helmet>
            <section className="px-6 md:px-12 py-5 bg-base-100 relative overflow-hidden -mt-4">
                <div className="absolute -top-24 -right-24 size-96 bg-primary/10 rounded-full blur-3xl"></div>
                <div className="absolute -bottom-24 -left-24 size-96 bg-blue-400/10 rounded-full blur-3xl"></div>

                <div className="max-w-5xl mx-auto relative">
                    <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-wider mb-6">
                        <span className="size-2 rounded-full bg-primary mr-2 animate-pulse"></span>
                        About HealthConnect
                    </span>

                    <h2 className="text-3xl md:text-5xl font-black text-text-main dark:text-white leading-[1.1] tracking-tight mb-8">
                        Connecting You to <span className="text-primary">Expert Care</span>
                    </h2>

                    <p className="text-lg text-text-secondary dark:text-slate-400 font-light max-w-2xl leading-relaxed">
                        We connect patients with certified, vetted nurses who deliver hospital-grade healthcare services in the comfort and safety of your own home.
                    </p>
                </div>
            </section>
            <section id='matching' className="py-10 px-6 bg-base-100 mb-10">
                <div className="">
                    <div className="text-center mb-16">
                        <h2 className="font-black text-text-main text-2xl md:text-3xl dark:text-white mb-6">
                            How We Match You to the <span className="text-primary">Perfect Nurse</span>
                        </h2>
                        <p className="text-lg text-secondary dark:text-slate-400 max-w-3xl mx-auto">
                            Our streamlined process ensures you're connected with qualified, vetted healthcare professionals who meet your specific needs.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" id="app-download">
                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-14 rounded-2xl bg-primary/20 group-hover:bg-primary/25 dark:bg-blue-900/30 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                                <FaDownload className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-3">1. Download App</h3>
                            <p className="text-secondary dark:text-slate-400 leading-relaxed text-sm">
                                Get the HealthConnect app and create your patient profile with basic information and contact details.
                            </p>
                            <hr className="my-3 border-slate-200 dark:border-slate-800" />
                            <button
                                onClick={() => {
                                    toast.success(utils.comminSoon)
                                }}
                                className="text-primary font-bold inline-flex items-center gap-2 group-hover:gap-3 transition-all text-sm"
                            >
                                Install link <span className="text-sm">→</span>
                            </button>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-14 rounded-2xl bg-primary/20 group-hover:bg-primary/25 dark:bg-blue-900/30 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                                <FaFileMedical className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-3">2. Add Conditions</h3>
                            <p className="text-secondary dark:text-slate-400 leading-relaxed text-sm">
                                Tell us about your health conditions, ailments, and care needs so we can find the right nurse for you.
                            </p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-14 rounded-2xl bg-primary/20 group-hover:bg-primary/25 dark:bg-blue-900/30 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                                <MdVerified className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-3">3. Smart Match</h3>
                            <p className="text-secondary dark:text-slate-400 leading-relaxed text-sm">
                                Our algorithm matches your conditions with qualified nurses nearby. Admin can also assign manually.
                            </p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-14 rounded-2xl bg-primary/20 group-hover:bg-primary/25 dark:bg-blue-900/30 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                                <FaHouseMedical className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-3">4. Receive Care</h3>
                            <p className="text-secondary dark:text-slate-400 leading-relaxed text-sm">
                                Your matched nurse arrives at your home with personalized care tailored to your specific health needs.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-20 px-6 bg-base-200/50">
                <div className="">
                    <div className="grid lg:grid-cols-3 gap-6">

                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-14 rounded-2xl bg-primary/20 group-hover:bg-primary/25 dark:bg-blue-900/30 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                                <FaHandHoldingHeart className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">Our Mission</h3>
                            <p className="text-secondary dark:text-slate-400 leading-relaxed">
                                To make quality healthcare accessible to every Kenyan family by connecting them with trusted, professional nurses who provide compassionate, hospital-grade care at home.
                            </p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-accent/30 transition-all duration-300">
                            <div className="size-14 rounded-2xl bg-accent/20 group-hover:bg-accent/25 dark:bg-teal-900/30 text-accent flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                                <FaMapMarkerAlt className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">Our Vision</h3>
                            <p className="text-secondary dark:text-slate-400 leading-relaxed">
                                To become Kenya's most trusted home healthcare platform, revolutionizing how families access medical care and creating a healthier nation, one home at a time.
                            </p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-success/30 transition-all duration-300">
                            <div className="size-14 rounded-2xl bg-success/20 group-hover:bg-success/25 dark:bg-green-900/30 text-success flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                                <FaStar className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">Our Goals</h3>
                            <p className="text-secondary dark:text-slate-400 leading-relaxed">
                                To build a network of 1000+ verified nurses, serve 10,000+ families across Kenya, and maintain a 98% patient satisfaction rate through excellence in care.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-16 px-6 bg-base-100">
                <div className="">
                    <div className="text-center mb-16">
                        <h2 className="text-2xl md:text-3xl font-black text-text-main dark:text-white mb-6">
                            Why Families <span className="text-primary">Trust Us</span>
                        </h2>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-12 rounded-xl bg-primary/20 text-primary flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                                <MdHealthAndSafety className="text-2xl" />
                            </div>
                            <h4 className="font-bold text-text-main dark:text-white mb-2">Verified Professionals</h4>
                            <p className="text-sm text-secondary dark:text-slate-400">Every nurse undergoes rigorous background checks and credential verification.</p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-12 rounded-xl bg-primary/20 text-primary flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                                <FaClock className="text-2xl" />
                            </div>
                            <h4 className="font-bold text-text-main dark:text-white mb-2">24/7 Availability</h4>
                            <p className="text-sm text-secondary dark:text-slate-400">Round-the-clock care whenever you need it, day or night.</p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-12 rounded-xl bg-primary/20 text-primary flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                                <FaShieldAlt className="text-2xl" />
                            </div>
                            <h4 className="font-bold text-text-main dark:text-white mb-2">Safe & Secure</h4>
                            <p className="text-sm text-secondary dark:text-slate-400">Your privacy and safety are our top priorities with encrypted data.</p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-12 rounded-xl bg-primary/20 text-primary flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                                <FaStar className="text-2xl" />
                            </div>
                            <h4 className="font-bold text-text-main dark:text-white mb-2">Quality Assured</h4>
                            <p className="text-sm text-secondary dark:text-slate-400">Hospital-grade care standards maintained in every home visit.</p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-12 rounded-xl bg-primary/20 text-primary flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                                <MdSupportAgent className="text-2xl" />
                            </div>
                            <h4 className="font-bold text-text-main dark:text-white mb-2">Dedicated Support</h4>
                            <p className="text-sm text-secondary dark:text-slate-400">Our team is always here to help you with any questions or concerns.</p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-5 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="size-12 rounded-xl bg-primary/20 text-primary flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                                <FaHeart className="text-2xl" />
                            </div>
                            <h4 className="font-bold text-text-main dark:text-white mb-2">Compassionate Care</h4>
                            <p className="text-sm text-secondary dark:text-slate-400">Nurses who genuinely care about your wellbeing and recovery.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="for-nurses" className="py-20 px-6 bg-base-200/50">
                <div className="">
                    <div className="text-center mb-12">
                        <h2 className="text-2xl md:text-3xl font-black text-text-main dark:text-white mb-6">
                            Join Our <span className="text-primary">Nurse Network</span>
                        </h2>
                        <p className="text-lg text-secondary dark:text-slate-400 max-w-3xl mx-auto leading-relaxed">
                            Are you a certified nurse looking to make a difference? Join HealthConnect and provide
                            compassionate care to patients in the comfort of their homes. Flexible schedules,
                            competitive pay, and the opportunity to build meaningful relationships with patients.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300 hover:-translate-y-1">
                            <div className="size-14 rounded-2xl bg-primary/20 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform relative">
                                <span className="absolute -top-2 -right-2 size-6 bg-primary text-white rounded-full text-xs font-bold flex items-center justify-center">
                                    1
                                </span>
                                <FaUserNurse className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-3">Register</h3>
                            <p className="text-secondary dark:text-slate-400 text-sm leading-relaxed">
                                Download our app, create your account with basic information including your name, contact details, and nursing credentials.
                            </p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300 hover:-translate-y-1">
                            <div className="size-14 rounded-2xl bg-accent/20 text-accent flex items-center justify-center mb-5 group-hover:scale-110 transition-transform relative">
                                <span className="absolute -top-2 -right-2 size-6 bg-accent text-white rounded-full text-xs font-bold flex items-center justify-center">
                                    2
                                </span>
                                <FaClipboardList className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-3">Complete Profile</h3>
                            <p className="text-secondary dark:text-slate-400 text-sm leading-relaxed">
                                Fill in your professional details, qualifications, specialties, availability, and service areas.
                            </p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300 hover:-translate-y-1">
                            <div className="size-14 rounded-2xl bg-success/20 text-success flex items-center justify-center mb-5 group-hover:scale-110 transition-transform relative">
                                <span className="absolute -top-2 -right-2 size-6 bg-success text-white rounded-full text-xs font-bold flex items-center justify-center">
                                    3
                                </span>
                                <FaFileUpload className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-3">Upload Documents</h3>
                            <p className="text-secondary dark:text-slate-400 text-sm leading-relaxed">
                                Submit your nursing license, ID, certificates, and other required documents for verification.
                            </p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300 hover:-translate-y-1">
                            <div className="size-14 rounded-2xl bg-primary/20 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform relative">
                                <span className="absolute -top-2 -right-2 size-6 bg-primary text-white rounded-full text-xs font-bold flex items-center justify-center">
                                    4
                                </span>
                                <MdVerified className="text-3xl" />
                            </div>
                            <h3 className="text-xl font-bold text-text-main dark:text-white mb-3">Get Verified</h3>
                            <p className="text-secondary dark:text-slate-400 text-sm leading-relaxed">
                                Our admin team reviews your application. Once approved, you're ready to start accepting jobs.
                            </p>
                        </div>
                    </div>

                    <div className="grid md:grid-cols-3 gap-6 mb-12">
                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="flex items-center gap-4 mb-4">
                                <div className="size-12 rounded-xl bg-primary/20 text-primary flex items-center justify-center group-hover:scale-110 transition-transform">
                                    <FaClock className="text-xl" />
                                </div>
                                <h4 className="font-bold text-text-main dark:text-white">Flexible Schedule</h4>
                            </div>
                            <p className="text-sm text-secondary dark:text-slate-400">
                                Choose when you want to work. Pick up shifts that fit your lifestyle and availability.
                            </p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="flex items-center gap-4 mb-4">
                                <div className="size-12 rounded-xl bg-primary/20 text-primary flex items-center justify-center group-hover:scale-110 transition-transform">
                                    <FaMoneyBillWave className="text-xl" />
                                </div>
                                <h4 className="font-bold text-text-main dark:text-white">Competitive Pay</h4>
                            </div>
                            <p className="text-sm text-secondary dark:text-slate-400">
                                Earn competitive rates with transparent pricing. Get paid promptly for every service rendered.
                            </p>
                        </div>

                        <div className="group bg-white dark:bg-slate-900 p-6 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                            <div className="flex items-center gap-4 mb-4">
                                <div className="size-12 rounded-xl bg-primary/20 text-primary flex items-center justify-center group-hover:scale-110 transition-transform">
                                    <FaHeart className="text-xl" />
                                </div>
                                <h4 className="font-bold text-text-main dark:text-white">Make a Difference</h4>
                            </div>
                            <p className="text-sm text-secondary dark:text-slate-400">
                                Build meaningful relationships with patients and provide care that truly impacts their lives.
                            </p>
                        </div>
                    </div>

                    <div className="text-center">
                        <button
                            onClick={() => {
                                const down = document.getElementById("app-download")
                                if (down) {
                                    down.scrollIntoView({ behavior: 'smooth' })
                                }
                            }}
                            className="inline-flex items-center gap-3 h-14 px-10 bg-primary text-white font-bold text-lg rounded-xl hover:bg-primary/90 transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1 group"
                        >
                            Register as Nurse
                            <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                        </button>
                    </div>
                </div>
            </section>

            <section className="py-20 px-6">
                <div className="">
                    <div className="bg-primary rounded-[2rem] p-12 md:p-16 relative overflow-hidden shadow-2xl">
                        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.15)_0%,transparent_70%)]"></div>

                        <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-12">

                            <div className="text-center lg:text-left max-w-2xl">
                                <h2 className="text-3xl md:text-5xl font-black text-white mb-6">
                                    Ready to Experience <br />Quality Home Healthcare?
                                </h2>
                                <p className="text-white/80 text-lg mb-10 max-w-2xl mx-auto lg:mx-0">
                                    Join the growing number of Kenyan families who trust HealthConnect for their healthcare needs.
                                </p>
                                <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start">
                                    <button
                                        onClick={() => {
                                            const down = document.getElementById("app-download")
                                            if (down) {
                                                down.scrollIntoView({ behavior: 'smooth' })
                                            }
                                        }}
                                        className="h-14 px-10 bg-white text-primary font-bold text-lg rounded-xl hover:bg-slate-50 transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2 group">
                                        Get Started Now
                                        <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                                    </button>
                                </div>
                            </div>

                            <div className="relative flex-shrink-0">
                                <div className="absolute inset-0 bg-white/10 rounded-full blur-3xl" />
                                <div className="relative size-32 md:size-48 lg:size-64 rounded-full border-[8px] md:border-[12px] lg:border-[16px] border-white/10 flex items-center justify-center mx-auto lg:mx-0">
                                    <FaHeartbeat className="text-4xl md:text-6xl lg:text-[100px] text-white/20" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </div>
    )
}

export default AboutPage